import useSWR from 'swr';
import { fetcher } from '../base';

export function useUserInfo({ skip } = { skip: false }) {
  return useSWR(!skip && '/user/info', fetcher, { revalidateOnFocus: false });
}
